import _ from 'lodash'
import Vue from 'vue'

const state = {
  relevantPolicy: [],
  relatedNews: [],
  categoryAll: [],
  links: [],
  apiValue: [],
  exporter: {},
  exporterAll: [],
  exporterPlaceholder: null,
  exporterReady: false,
  importer: {},
  importerAll: [],
  importerPlaceholder: null,
  importerReady: false,
  productReady: false,
  productPlaceholder: null,
  rootParentCode: '0'
}

const localState = {
  products: {},
  productsLen: [],
  productRefImportID: null,
  productCollection: {}
}

function _getAllExporter (_exporter) {
  if (_.isEmpty(_exporter)) {
    return []
  } else {
    let res = _.concat([], _exporter.hot || [])
    _.each(_exporter.continent || [], (item) => {
      res.push(...item.areas || [])
    })
    _.each(_exporter.fta || [], (item) => {
      res.push(...item.areas || [])
    })
    return _.uniqBy(res, 'name')
  }
}
function _getAllImporter (_importer) {
  return _getAllExporter(_importer)
}
function _getNativeProduct (_products, level = 1) {
  let items = {}
  _products = _products.leafs || []
  for (let i = 0; i < _products.length; i++) {
    items[`level${level}`] = items[`level${level}`] || []
    items[`level${level}`].push(_.extend({_level: level}, {
      id: _products[i]['data'].id,
      code: _products[i]['data'].code,
      name: _products[i]['data'].name,
      parentCode: _products[i]['data'].parentCode,
      abb: _products[i]['data'].abb || '',
      spell: _products[i]['data'].spell || ''
    }))
    if (_products[i].leafs && _products[i].leafs.length > 0) {
      items[`level${level + 1}`] = items[`level${level + 1}`] || []
      _.mergeWith(items, _getNativeProduct(_products[i], level + 1), (objValue, srcValue) => {
        if (_.isArray(objValue)) {
          return objValue.concat(srcValue)
        }
      })
    }
  }
  return items
}
function _getProductChildByCode (parentCode, collItem, isOne = false) {
  if (isOne) {
    return _.find(collItem, item => item.parentCode === parentCode)
  } else {
    return _.filter(collItem, item => item.parentCode === parentCode)
  }
}
function _searchProductAndChildrenByCode (code, coll, level) {
  let parentNode = _.find(coll[`level${level}`] || [], (item) => {
    return item.code === code
  })
  let res = []
  if (parentNode) {
    parentNode = _.assign({}, parentNode)
    parentNode['children'] = _getProductChildByCode(code, coll[`level${level + 1}`] || [])
    res.push(parentNode)
  }
  return res
}
function _searchProductByCode (code, coll) {
  let node = null
  _.each(coll, (valueArr, levelName) => {
    node = _.find(valueArr, (item) => {
      return item.code === code
    })
    if (node) return false
  })
  if (_.isEmpty(node)) {
    return null
  } else {
    return node
  }
}
function _searchIsLastProductByCode (key, coll) {
  key = _.escapeRegExp(key)
  if (key) {
    let node = null
    _.each(coll, (valueArr, levelName) => {
      node = _.find(valueArr, (item) => {
        return (new RegExp(key, 'i')).test(item.name) || (new RegExp(`^${key}`, 'i')).test(item.abb) || (new RegExp(`^${key}`, 'i')).test(item.code) || (new RegExp(`^${key}`, 'i')).test(item.spell)
      })
      if (node) return false
    })
    if (_.isEmpty(node)) return null
    let children = _getProductChildByCode(node.code, coll[`level${node._level + 1}`] || [], true)
    if (children) {
      let child = _getProductChildByCode(children.code, coll[`level${children._level + 1}`] || [], true)
      if (child) return null
      return children
    } else {
      return node
    }
  } else {
    return null
  }
}
function _searchProductsByName (key, coll) {
  key = _.escapeRegExp(key)
  if (key) {
    let arr = []
    let codeLenMedian = localState.productsLen[localState.productsLen.length - 2] || 6
    if (/^\*?\d+?$/.test(key) && key.length >= codeLenMedian) {
      _.forEachRight(coll, (valueArr, levelName) => {
        arr = _.filter(valueArr, (item) => {
          return (new RegExp(`^${key}`, 'i')).test(item.code)
        })
        if (arr.length > 0) return false
      })
    } else {
      _.each(coll, (valueArr, levelName) => {
        arr = _.filter(valueArr, (item) => {
          return (new RegExp(key, 'i')).test(item.name) || (new RegExp(`^${key}`, 'i')).test(item.abb) || (new RegExp(`^${key}`, 'i')).test(item.code) || (new RegExp(`^${key}`, 'i')).test(item.spell)
        })
        if (arr.length > 0) return false
      })
    }
    if (_.isEmpty(arr)) {
      return []
    }
    arr = _.sortBy(arr, 'code')
    let nextLevel = arr[0]['_level'] + 1
    if (coll[`level${nextLevel}`]) {
      for (let i = 0; i < arr.length; i++) {
        arr[i] = _.assign({}, arr[i])
        arr[i]['children'] = _.filter(coll[`level${nextLevel}`] || [], (item) => {
          return item.parentCode === arr[i]['code']
        })
      }
    }
    return arr
  } else {
    return []
  }
}

const getters = {
  getApiValue: (state, getters, rootState, rootGetters) => (key) => {
    return _.find(state.apiValue, (item) => {
      return parseInt(item.id) === parseInt(key)
    }) || {}
  },
  getAutoCompleteExporter: (state, getters, rootState, rootGetters) => (key) => {
    
    if(!state.exporterAll){
      return []
    }
    let arr = state.exporterAll
    if (arr.length === 0) {
      arr = _getAllExporter(state.exporter)
    }
    key = _.trim(key || '')
    if (key) {
      key = _.escapeRegExp(key)
      arr = _.filter(arr, (item) => {
        return (new RegExp(key, 'i')).test(item.name) || (new RegExp(`^${key}`, 'i')).test(item.abb) || (new RegExp(`^${key}`, 'i')).test(item.code) || (new RegExp(`^${key}`, 'i')).test(item.spell)
      })
    }
    return arr
  },
  getExporterById: (state, getters, rootState, rootGetters) => (id) => {
    let arr = state.exporterAll
    if (arr.length === 0) return null
    id = _.trim(id || '')
    if (id) {
      return _.find(arr, (item) => {
        return item.id === parseInt(id)
      })
    } else {
      return null
    }
  },
  getAutoCompleteImporter: (state, getters, rootState, rootGetters) => (key) => {
    let arr = state.importerAll
    if (arr.length === 0) {
      arr = _getAllImporter(state.exporter)
    }
    key = _.trim(key || '')
    if (key) {
      key = _.escapeRegExp(key)
      arr = _.filter(arr, (item) => {
        return (new RegExp(key, 'i')).test(item.name) || (new RegExp(`^${key}`, 'i')).test(item.abb) || (new RegExp(`^${key}`, 'i')).test(item.code) || (new RegExp(`^${key}`, 'i')).test(item.spell)
      })
    }
    return arr
  },
  getImporterById: (state, getters, rootState, rootGetters) => (id) => {
    let arr = state.importerAll
    if (arr.length === 0) return null
    id = _.trim(id || '')
    if (id) {
      return _.find(arr, (item) => {
        return item.id === parseInt(id)
      })
    } else {
      return null
    }
  },
  getAutoCompleteProduct: (state, getters, rootState, rootGetters) => (key) => {
    let products = localState.products
    if (_.isEmpty(products)) {
      return []
    } else {
      key = _.trim(key || '')
      if (key) {
        return _searchProductsByName(key, products)
      } else {
        return products['level1']
      }
    }
  },
  getParentByCode: (state, getters, rootState, rootGetters) => (code, level) => {
    let products = localState.products
    if (_.isEmpty(products)) {
      return []
    } else {
      code = _.trim(code || '')
      level = parseInt(level) || 0
      if (level && level > 1 && code && code !== state.rootParentCode) {
        let res = _searchProductAndChildrenByCode(code, products, level - 1)
        if (res && res.length > 0) {
          return res
        } else {
          return products['level1']
        }
      } else {
        return products['level1']
      }
    }
  },
  getChildByCode: (state, getters, rootState, rootGetters) => (code, level) => {
    let products = localState.products
    if (_.isEmpty(products)) {
      return []
    } else {
      code = _.trim(code || '')
      level = parseInt(level) || 0
      if (level && level > 0 && code) {
        return _searchProductAndChildrenByCode(code, products, level)
      } else {
        return []
      }
    }
  },
  getIsLastProductByCode: (state, getters, rootState, rootGetters) => (key) => {
    let products = localState.products
    if (_.isEmpty(products)) {
      return null
    } else {
      key = _.trim(key || '')
      if (key) {
        return _searchIsLastProductByCode(key, products)
      } else {
        return null
      }
    }
  },
  getProductByCode: (state, getters, rootState, rootGetters) => (code) => {
    let products = localState.products
    if (_.isEmpty(products)) {
      return null
    } else {
      code = _.trim(code || '')
      if (code) {
        return _searchProductByCode(code, products)
      } else {
        return null
      }
    }
  },
  getTopProduct: (state, getters, rootState, rootGetters) => () => {
    let products = localState.products
    return products['level1'] || []
  },
  getImporterAll (state, getters, rootState, rootGetters) {
    return state.importerAll
  }
}

const mutations = {
  setRelevantPolicy (state, value) {
    state.relevantPolicy = value || []
  },
  setRelatedNews (state, value) {
    state.relatedNews = value || []
  },
  setCategory (state, value) {
    state.categoryAll = value || []
  },
  setLinks (state, value) {
    state.links = value || []
  },
  setApiValue (state, value) {
    state.apiValue = value || []
  },
  setExporter (state, value) {
    value = value || {}
    state.exporter = value
    state.exporterAll = _getAllExporter(value)
    if (_.isEmpty(value.hot) && !_.isEmpty(state.exporterAll)) {
      state.exporterPlaceholder = state.exporterAll[0]
    } else {
      state.exporterPlaceholder = value.hot[0]
    }
    state.exporterReady = true
  },
  setImporter (state, value) {
    value = value || {}
    state.importer = value
    state.importerAll = _getAllImporter(value)
    if (_.isEmpty(value.hot) && !_.isEmpty(state.importerAll)) {
      state.importerPlaceholder = state.importerAll[0]
    } else {
      state.importerPlaceholder = value.hot[0]
    }
    state.importerReady = true
    // this.dispatch('data/asyncAddProducts', state.importerAll)
    this.dispatch('search/asyncHistoryData', true)
  },
  setProducts (state, value) {
    value = value || {}
    localState.products = _getNativeProduct(value)
    state.productReady = true
    if (!_.isEmpty(localState.products)) {
      _.forEachRight(localState.products, (arr, key) => {
        if (window.$lang === 'zh-CN') {
          let res = _.find(arr, item => item.code === '22059000')
          if (res) {
            state.productPlaceholder = res
            return false
          }
        } else {
          state.productPlaceholder = arr[0]
          return false
        }
      })
      if (!state.productPlaceholder) {
        _.forEachRight(localState.products, (arr, key) => {
          state.productPlaceholder = arr[0]
          return false
        })
      }
      _.each(localState.products, (valueArr, levelName) => {
        localState.productsLen.push(valueArr[0].code.length)
      })
    }
    localState.productRefImportID = state.importerPlaceholder.id
    localState.productCollection[state.importerPlaceholder.id] = {
      products: localState.products,
      productPlaceholder: state.productPlaceholder,
      productsLen: localState.productsLen
    }
  },
  addProducts (state, params) {
    if (!(params.importerID in localState.productCollection)) {
      params.value = params.value || {}
      let _productsLen = []
      let _productPlaceholder = null
      let _products = _getNativeProduct(params.value)
      if (!_.isEmpty(_products)) {
        _.forEachRight(_products, (arr, key) => {
          _productPlaceholder = arr[0]
          return false
        })
        _.each(_products, (valueArr, levelName) => {
          _productsLen.push(valueArr[0].code.length)
        })
      }
      localState.productCollection[params.importerID] = {
        products: _products,
        productPlaceholder: _productPlaceholder,
        productsLen: _productsLen
      }
    }
    this.commit('data/setCurrentProduct')
  },
  setCurrentProduct (state, isChangeTab = false) {
    if (state.importerAll.length <= 1) return
    let currentImporter = this.getters['search/importer/getRelValue']
    let isClean = true
    console.log('currentImporter' + currentImporter)
    if (currentImporter && currentImporter.id) {
      if (!isChangeTab && localState.productRefImportID && parseInt(currentImporter.id) !== parseInt(localState.productRefImportID)) {
        this.dispatch('search/product/asyncProductState', '')
      }
      if (localState.productRefImportID && parseInt(currentImporter.id) === parseInt(localState.productRefImportID)) {
        isClean = false
      } else if (currentImporter.id in localState.productCollection) {
        isClean = false
        localState.productRefImportID = currentImporter.id
        state.productPlaceholder = localState.productCollection[currentImporter.id].productPlaceholder
        state.productReady = true
        localState.products = localState.productCollection[currentImporter.id].products
        localState.productsLen = localState.productCollection[currentImporter.id].productsLen
      }
    } else if (localState.productRefImportID) {
      isClean = false
      if (state.importerPlaceholder && state.importerPlaceholder.id) {
        localState.productRefImportID = state.importerPlaceholder.id
        state.productPlaceholder = localState.productCollection[state.importerPlaceholder.id].productPlaceholder
        state.productReady = true
        localState.products = localState.productCollection[state.importerPlaceholder.id].products
        localState.productsLen = localState.productCollection[state.importerPlaceholder.id].productsLen
      }
    }
    if (isClean) {
      localState.productRefImportID = null
      state.productPlaceholder = null
      state.productReady = false
      localState.products = {}
      localState.productsLen = []
    }
  }
}

const actions = {
  asyncAddProducts ({ commit, state, rootState, rootGetters }, importers) {
    for (let i = 0; i < importers.length; i++) {
      // if (importers[i].id !== state.importerPlaceholder.id) {
        Vue._api.getHSProducts(importers[i].id, {
          success (response) {
            if (response.data.code === 200) {
              commit('addProducts', {
                importerID: importers[i].id,
                value: _.isEmpty(response.data.data) ? {} : response.data.data.hsTree
              })
            }
          }
        })
      // }
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/data.js